<ng-container
  *ngrxLet="{
    dhwPumpsCirculation: dhwPumpsCirculation$ | async | ready,
    dhwConfigurationPumpsCirculationModeFeature:
      dhwConfigurationPumpsCirculationMode$ | async | ready,
    dhwConfigurationPumpsCirculationCycleConfigurationFeature:
      dhwConfigurationPumpsCirculationCycleConfiguration$ | async | ready,
    dhwConfigurationPumpsCirculationParallelHygiene:
      dhwConfigurationPumpsCirculationParallelHygiene$ | async | ready,
    dhwConfigurationPumpsCirculationParallelDhwHeating:
      dhwConfigurationPumpsCirculationParallelDhwHeating$ | async | ready
  } as context"
>
  <div
    class="section-wrapper"
    *ngIf="
      context.dhwPumpsCirculation &&
      (context.dhwConfigurationPumpsCirculationModeFeature ||
        context.dhwConfigurationPumpsCirculationCycleConfigurationFeature ||
        context.dhwConfigurationPumpsCirculationParallelHygiene ||
        context.dhwConfigurationPumpsCirculationParallelDhwHeating)
    "
  >
    <h3 class="static-heading">
      {{
        '+INSTALLATIONS.INSTALLATION.ELECTRIC_HEATER.DHW.LABEL_CIRCULATION_PUMP_SETTINGS'
          | translate
      }}
    </h3>
    <div *ngIf="context.dhwConfigurationPumpsCirculationModeFeature">
      <mat-form-field class="gt-md:!hidden operating-mode-dropdown" mat-select-height-large>
        <mat-label>{{
          '+INSTALLATIONS.INSTALLATION.DHW_ACTIVE_OPERATING_MODE' | translate
        }}</mat-label>
        <mat-select
          [attr.data-at-circulation-pump-operating-mode]="
            context.dhwConfigurationPumpsCirculationModeFeature.properties?.value?.value
          "
          (selectionChange)="onCirculationModeChange($event.value)"
          [disabled]="
            !(
              context.dhwConfigurationPumpsCirculationModeFeature
              | executable: featureCommands.setMode
            )
          "
          [value]="context.dhwConfigurationPumpsCirculationModeFeature.properties?.value?.value"
          fieldTextContentTooltip
        >
          <mat-option
            *ngFor="
              let mode of context.dhwConfigurationPumpsCirculationModeFeature.commands?.setMode
                ?.params?.mode?.constraints?.enum
            "
            [value]="mode"
            [attr.data-at-option]="mode"
            gtm="onSelect"
            gtmAction="Select Operating Mode"
            gtmCategory="heatingCircuit"
            fieldTextContentTooltip
            >{{ mode | translateOperatingProgram }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <ng-container *ngIf="context.dhwConfigurationPumpsCirculationCycleConfigurationFeature">
        <mat-form-field class="gt-md:!hidden operating-mode-dropdown" mat-select-height-large>
          <mat-label>{{ '+INSTALLATIONS.INSTALLATION.DHW_CYCLES_PER_HOUR' | translate }}</mat-label>
          <mat-select
            [attr.data-at-circulation-cycles]="
              context.dhwConfigurationPumpsCirculationCycleConfigurationFeature.properties?.value
                ?.value
            "
            (selectionChange)="onCirculationCycleConfigurationChange($event.value)"
            [disabled]="
              !(
                context.dhwConfigurationPumpsCirculationCycleConfigurationFeature
                | executable: featureCommands.setMode
              )
            "
            [value]="
              context.dhwConfigurationPumpsCirculationCycleConfigurationFeature.properties?.value
                ?.value
            "
            fieldTextContentTooltipS
          >
            <mat-option
              *ngFor="
                let mode of context.dhwConfigurationPumpsCirculationCycleConfigurationFeature
                  .commands?.setMode?.params?.mode?.constraints?.enum
              "
              [value]="mode"
              [attr.data-at-option]="mode"
              gtm="onSelect"
              gtmAction="Select Operating Mode"
              gtmCategory="heatingCircuit"
              fieldTextContentTooltip
              >{{ mode | translateOperatingProgram }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </ng-container>
      <ng-container
        *ngIf="dhwConfigurationPumpsCirculationTriggerCycleDuration$ | async | ready as feature"
      >
        <mat-form-field class="gt-md:!hidden operating-mode-dropdown" mat-select-height-large>
          <mat-label>{{ '+INSTALLATIONS.INSTALLATION.DHW_CYCLE_DURATION' | translate }}</mat-label>
          <mat-select
            (selectionChange)="onTriggerCycleDurationChange($event.value)"
            [disabled]="!(feature | executable: featureCommands.setValue)"
            [value]="feature.properties?.value?.value"
            fieldTextContentTooltip
          >
            <mat-option
              *ngFor="let mode of dataOfAvailableTriggeredCycleDuration"
              [value]="mode.value"
              gtm="onSelect"
              gtmAction="Select Operating Mode"
              gtmCategory="heatingCircuit"
              fieldTextContentTooltip
            >
              {{ mode.value }}
              {{
                '+INSTALLATIONS.INSTALLATION.DHW_CYCLE_DURATION_' + (mode.unit | uppercase)
                  | translate
              }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </ng-container>
    </div>
    <div class="toggle-container">
      <div
        *ngIf="context.dhwConfigurationPumpsCirculationParallelHygiene"
        class="gap slide-toggle-container"
      >
        <mat-slide-toggle
          [attr.data-at-active-during-hygiene-program-toggle]="
            context.dhwConfigurationPumpsCirculationParallelHygiene.properties?.active?.value
          "
          class="slide-toggle"
          [checked]="
            context.dhwConfigurationPumpsCirculationParallelHygiene.properties?.active?.value
          "
          (click)="
            onActiveDuringHygiene(
              $event,
              !context.dhwConfigurationPumpsCirculationParallelHygiene.properties?.active.value
            )
          "
        >
          {{
            '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_ACTIVE_DURING_HYGIENE_PROGRAM' | translate
          }}
        </mat-slide-toggle>
      </div>
      <div
        *ngIf="context.dhwConfigurationPumpsCirculationParallelDhwHeating"
        class="gap slide-toggle-container"
      >
        <mat-slide-toggle
          [attr.data-at-active-during-heating-toggle]="
            context.dhwConfigurationPumpsCirculationParallelDhwHeating.properties?.active?.value
          "
          class="slide-toggle"
          [checked]="
            context.dhwConfigurationPumpsCirculationParallelDhwHeating.properties?.active?.value
          "
          (click)="
            onActiveDuringDHWHeating(
              $event,
              !context.dhwConfigurationPumpsCirculationParallelDhwHeating.properties?.active.value
            )
          "
        >
          {{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_ACTIVE_DURING_HEATING' | translate }}
        </mat-slide-toggle>
      </div>
    </div>
  </div>
</ng-container>
<div class="mt-4">
  <app-hygiene></app-hygiene>
</div>
